import { render, staticRenderFns } from "./GiftCardMain.vue?vue&type=template&id=5976a0ee"
import script from "./GiftCardMain.vue?vue&type=script&lang=js"
export * from "./GiftCardMain.vue?vue&type=script&lang=js"
import style0 from "./GiftCardMain.vue?vue&type=style&index=0&id=5976a0ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports